import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import useWindowSize from '../new-service/useWindowSize';
import NotificationBell from '../notifications/NotificationBell';
import LocationPicker from '../multiLocation/LocationPicker';

const ClientListIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

const DataSharingIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
);

const BackArrowIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
    </svg>
);

const navItems = [
    { id: 'clientList', label: 'Client List', icon: <ClientListIcon /> },
    { id: 'dataSharing', label: 'Data Sharing', icon: <DataSharingIcon /> },
];

function ClientsTopNav({ activeTab, onTabChange, children, history }) {
    const { width } = useWindowSize();
    const isMobile = width <= 1100;

    const getCurrentTitle = () => {
        const item = navItems.find(n => n.id === activeTab);
        return item ? item.label : 'Clients';
    };

    if (isMobile) {
        return (
            <div className="catalogue-mobile-header">
                <button className="catalogue-mobile-back-btn" onClick={() => history.goBack()}>
                    <BackArrowIcon />
                </button>
                <h1 className="catalogue-mobile-title">{getCurrentTitle()}</h1>
                <div className="catalogue-mobile-actions">
                    <LocationPicker slot="mobile" />
                    {children}
                </div>
            </div>
        );
    }

    return (
        <div className="catalogue-top-nav">
            <div className="catalogue-top-nav-container">
                <div className="catalogue-top-nav-content">
                    <nav className="catalogue-tabs-nav">
                        {navItems.map(item => (
                            <button
                                key={item.id}
                                className={`catalogue-tab-btn${activeTab === item.id ? ' active' : ''}`}
                                onClick={() => onTabChange(item.id)}
                            >
                                {item.icon}
                                <span>{item.label}</span>
                            </button>
                        ))}
                    </nav>
                    <div className="catalogue-nav-actions">
                        {children}
                    </div>
                </div>
            </div>
            <div className="notif-bell-pinned-wrap">
                <LocationPicker />
                <NotificationBell />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(ClientsTopNav));
